import React, { useMemo, useState } from 'react';
import { Icon } from '@iconify/react';
import hebergementService from '../../services/hebergementService';

function flattenTypeOptions(groups = []) {
  return groups.flatMap((group) => (group.options ?? []).map((opt) => ({
    value: String(opt.value ?? opt.id),
    label: opt.label ?? opt.libelle ?? String(opt.id),
  })));
}

const SiteTypeInlineCell = ({
  siteInfo,
  typesSiteGroups = [],
  apiWorking,
  onUpdated,
}) => {
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [query, setQuery] = useState('');

  const allTypeOptions = useMemo(() => flattenTypeOptions(typesSiteGroups), [typesSiteGroups]);

  const currentId = siteInfo.typeSiteId
    ? String(siteInfo.typeSiteId)
    : (siteInfo.typeSitePrincipale ? String(siteInfo.typeSitePrincipale) : '');

  const currentLabel = siteInfo.typeSiteLabel || null;

  const needle = query.trim().toLowerCase();
  const visible = useMemo(() => {
    if (!needle) return allTypeOptions;
    return allTypeOptions.filter((option) => option.label.toLowerCase().includes(needle));
  }, [allTypeOptions, needle]);

  const saveTypeSite = async (values) => {
    if (!apiWorking || saving) return;

    const normalized = values?.[0] ? String(values[0]) : null;
    const current = currentId || null;

    if (normalized === current || (normalized === null && !current)) {
      setEditing(false);
      return;
    }

    setSaving(true);
    try {
      const response = await hebergementService.updateTypeSite(siteInfo.id, normalized);
      if (response.success && response.data) {
        onUpdated?.(siteInfo.id, response.data);
      }
      setEditing(false);
    } catch (err) {
      console.error('Erreur mise à jour type de site:', err);
      setEditing(false);
    } finally {
      setSaving(false);
    }
  };

  const open = (event) => {
    event.stopPropagation();
    if (!apiWorking || saving) return;
    setQuery('');
    setEditing(true);
  };

  return (
    <span className="sw-type-wrap">
      {currentLabel ? (
        <button type="button" className="sw-type" title="Changer le type de site" onClick={open} disabled={saving}>
          {currentLabel}
          <Icon icon="lucide:chevron-down" width={12} />
        </button>
      ) : (
        <button type="button" className="sw-add" onClick={open} disabled={saving}>
          <Icon icon="lucide:plus" width={12} />
          Type de site
        </button>
      )}
      {editing ? (
        <>
          <div className="sw-pop__backdrop" onClick={() => setEditing(false)} />
          <div className="sw-pop" onClick={(event) => event.stopPropagation()}>
            <label className="sw-select__find">
              <Icon icon="lucide:search" width={14} />
              <input
                autoFocus
                value={query}
                onChange={(event) => setQuery(event.target.value)}
                placeholder="Rechercher un type…"
              />
            </label>
            <div className="sw-pop__list">
              {visible.map((option) => {
                const on = option.value === currentId;
                return (
                  <button
                    key={option.value}
                    type="button"
                    className={`sw-select__opt${on ? ' is-on' : ''}`}
                    onClick={() => saveTypeSite([option.value])}
                  >
                    <span style={{ flex: 1, minWidth: 0 }}>{option.label}</span>
                    {on ? <Icon icon="lucide:check" width={14} style={{ color: 'var(--sw-accent)' }} /> : null}
                  </button>
                );
              })}
              {visible.length === 0 ? (
                <span className="sw-select__empty">Aucun type trouvé</span>
              ) : null}
            </div>
            {currentLabel ? (
              <button type="button" className="sw-pop__clear" onClick={() => saveTypeSite([])}>
                <Icon icon="lucide:x" width={13} />
                Retirer le type
              </button>
            ) : null}
          </div>
        </>
      ) : null}
    </span>
  );
};

export default SiteTypeInlineCell;
